import { Typography } from "@mui/material";

function Welcome (){
    return(
        <Typography>Welcome</Typography>
    );
}

export default Welcome;